import { tryJsonParse } from "./json-utils"

export function encodeData<T>(data: T): string {
  const jsonString = JSON.stringify(data)
  return btoa(encodeURIComponent(jsonString))
}

export function decodeData<T>(encodedData: string): T | undefined {
  const jsonString = decodeURIComponent(atob(encodedData))
  return tryJsonParse<T>(jsonString)
}
